module.exports = __webpack_public_path__ + "static/media/info.f4471ce7.svg";